import { buildLink } from '@/utils';
import { Alert, Button } from '@e2n/ui/v2';
import { faWandMagicSparkles } from '@fortawesome/pro-regular-svg-icons';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

// oxlint-disable-next-line max-lines-per-function
export function NextSteps() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const showFristenWarning = Boolean(searchParams.get('FristenWarning'));
  const showPersonalzugangWarning = Boolean(
    searchParams.get('PersonalzugangWarning'),
  );
  const showPersonalfragebogenWarning = Boolean(
    searchParams.get('PersonalfragebogenWarning'),
  );

  const handleNavigation = (to: 'create' | 'mitarbeiterList') => {
    if (to === 'create') {
      navigate('/mitarbeiter/create');
    } else if (to === 'mitarbeiterList') {
      window.location.replace(buildLink('mitarbeiterListe'));
    }
  };

  return (
    <div className="flex flex-col gap-4 items-center w-96">
      {showFristenWarning && (
        <Alert
          variant="warning"
          showIcon
          className="w-full"
          title={t('domain.mitarbeiter.create.success.warning.fristen.title')}
          showDescription
          description={t(
            'domain.mitarbeiter.create.success.warning.fristen.description',
          )}
        />
      )}
      {showPersonalzugangWarning && (
        <Alert
          variant="warning"
          showIcon
          className="w-full"
          title={t(
            'domain.mitarbeiter.create.success.warning.personalzugang.title',
          )}
          showDescription
          description={t(
            'domain.mitarbeiter.create.success.warning.personalzugang.description',
          )}
        />
      )}
      {showPersonalfragebogenWarning && (
        <Alert
          variant="warning"
          showIcon
          className="w-full"
          title={t(
            'domain.mitarbeiter.create.success.warning.personalfragebogen.title',
          )}
          showDescription
          description={t(
            'domain.mitarbeiter.create.success.warning.personalfragebogen.description',
          )}
        />
      )}
      <Button
        className="flex gap-3 h-16 p-4 bg-neutrals-v2-200 rounded-xl text-labels-primary hover:bg-neutrals-v2-300 w-full"
        onClick={() => handleNavigation('create')}>
        <FontAwesomeIcon icon={faWandMagicSparkles} />
        <span>
          {t('domain.mitarbeiter.create.success.nextSteps.assistent')}
        </span>
        <FontAwesomeIcon
          icon={faArrowRight}
          className="ml-auto text-brand-red-200 size-4"
        />
      </Button>

      <Button
        variant="ghost"
        onClick={() => handleNavigation('mitarbeiterList')}>
        {t('domain.mitarbeiter.create.success.nextSteps.back')}
      </Button>
    </div>
  );
}
